import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GetGroupsBychannels } from '../../../../../core/shared/actions/group.assignment.actions';
import { GroupAssignmentState } from '../../../../../core/shared/states/group.assignment.state';
import { DeveloperApplicationSubscriptionModalComponent } from '../../modals/developer-application-subscription-modal/developer-application-subscription-modal.component';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { SubscriptionModel } from '../../../../../core/shared/models/subscription.model';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-developer-application-subscriptions-list',
  templateUrl: './developer-application-subscriptions-list.component.html',
  styleUrls: ['./developer-application-subscriptions-list.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatIcon,
    MatIconButton,
    LoadingSpinnerComponent,
  ],
})
export class DeveloperApplicationSubscriptionsListComponent
  implements AfterViewInit, OnInit
{
  public subscription!: SubscriptionModel;
  public dataSource = new MatTableDataSource<SubscriptionModel>();
  public displayedColumns = ['group_name', 'channel_name', 'Description', 'actions'];
  public loading = true;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() applicationName!: string;
  public readonly subscriptions: Observable<
    SubscriptionModel[]
  >;

  constructor(private store: Store, public modalService: NgbModal) {
    this.subscriptions = this.store.select(GroupAssignmentState.getGroupList);
  }

  ngOnInit() {
    this.store.dispatch(new GetGroupsBychannels(this.applicationName));

    this.subscriptions.subscribe((data) => {
      this.dataSource.data = data;
      this.loading = false;
    });
  }

  openModal(
    applicationName: string,
    subscription: SubscriptionModel,
    formMode: string,
    editSubscription: boolean
  ) {
    // Open modal form component
    const modalRef = this.modalService.open(
      DeveloperApplicationSubscriptionModalComponent,
      {
        size: 'lg',
      }
    );
    // pass into form component variable
    modalRef.componentInstance.subscription = subscription;
    modalRef.componentInstance.applicationName = applicationName;
    modalRef.componentInstance.editSubscription = editSubscription;
    // pass into form component variable formMode
    modalRef.componentInstance.formMode = formMode;
    // handle result passing back from modal form component
    //modalRef.result.then(() => {});
  }
  //search bar
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
